import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-p', 'IconLetterP', [
  ['path', { d: 'M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5', key: 'svg-0' }],
]);
